import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../sections/Header";
import Footer from "../sections/Footer";

const Layout: React.FC = () => {
  return (
    <>
      <section className="bg-[#EAEEFE] flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
      </section>
    </>
  );
};

export default Layout;
